module.exports = function() {
  return new Worker(__webpack_public_path__ + "56f37ec2100e43d0d436.worker.js");
};